import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { Owned } from 'shell-models-lib';
import { BaseAdapter } from 'app/model/adapters/base.adapter';
import { StoreWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/store-write-settings';
import { FormatTypeCopySink } from 'app/model/pipeline/copysink/format-type.copysink';

export class GenericStoreWriteSettingsAdapter extends BaseAdapter<StoreWriteSettings, Model.StoreWriteSettings> {
    protected _toResource(settings: StoreWriteSettings): Model.StoreWriteSettings {
        const settingsType = Metamodel.modelOf(settings).name;
        const result: Model.StoreWriteSettings = {
            type: settingsType
        };
        return result;
    }

    protected _toModel(settings: Model.StoreWriteSettings, copySink: FormatTypeCopySink): StoreWriteSettings {
        const model = Metamodel.modelByName(settings.type);
        const result = Owned.create<StoreWriteSettings>(model, copySink);
        return result;
    }
}
